import { forwardRef, ReactNode, useMemo } from 'react'
import { DocumentZoom } from './Documents/DocumentZoom'
import { useDocumentState } from '@/state'
import { cn } from '@/utils'

export const DocumentContainer = forwardRef<
  HTMLDivElement,
  { children: ReactNode }
>(({ children }, ref) => {
  return (
    <div className="h-full">
      <div
        className="h-full overflow-y-scroll overflow-x-auto relative"
        ref={ref}
      >
        {children}
      </div>
      <DocumentZoom />
    </div>
  )
})
DocumentContainer.displayName = 'DocumentContainer'

export const InnerDocumentContainer = forwardRef<
  HTMLDivElement,
  { children: ReactNode }
>(({ children }, ref) => {
  return (
    <div className="absolute h-full w-full top-0 left-0 print:relative print:h-auto">
      <div
        ref={ref}
        className="space-y-4 grid justify-items-center px-4 pb-6 w-full print:space-y-0 print:px-0 print:pb-0 print:m-0 bg-slate-50"
      >
        {children}
      </div>
    </div>
  )
})

InnerDocumentContainer.displayName = 'InnerDocumentContainer'

export const VirtualDocumentContainer = forwardRef<
  HTMLDivElement,
  { children: ReactNode; zoom: number; top: number; height: number }
>(({ children, zoom, top, height }, ref) => {
  const zoomFactor = useMemo(() => zoom / 100, [zoom])

  const isUserSelectDisabled = useDocumentState(
    (state) => state.isUserSelectDisabled,
  )
  return (
    <div
      ref={ref}
      style={{
        position: 'absolute',
        top,
        left: 0,
        width: '100%',
        height,
        overflow: 'visible',
      }}
    >
      <div
        style={{
          transform: `scale(${zoomFactor})`,
          transformOrigin: '0 0',
          width: 792,
        }}
        className={cn({
          'select-none': isUserSelectDisabled,
        })}
      >
        {children}
      </div>
    </div>
  )
})

VirtualDocumentContainer.displayName = 'VirtualDocumentContainer'
